import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { API_URL } from "../utils/api";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (password.length < 6) {
      setError("Le mot de passe doit faire au moins 6 caractères");
      return;
    }
    if (password !== confirm) {
      setError("Les mots de passe ne correspondent pas");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || "Lien invalide ou expiré");
      } else {
        setDone(true);
        setTimeout(() => navigate("/login"), 3000);
      }
    } catch {
      setError("Impossible de se connecter au serveur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ height: "100%", overflowY: "auto", WebkitOverflowScrolling: "touch", backgroundColor: "#F5F5F5", display: "flex", alignItems: "center", justifyContent: "center", padding: 20, boxSizing: "border-box" }}>
      <div style={{ backgroundColor: "white", borderRadius: 24, padding: 40, maxWidth: 420, width: "100%", boxShadow: "0 20px 60px rgba(0,0,0,0.12)" }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <img src="/oltodo.png" alt="OLTODO" style={{ width: 56, height: 56, objectFit: "contain", margin: "0 auto 12px" }} />
          <div style={{ fontWeight: 900, fontSize: 20, letterSpacing: 3, color: "#0a0a0a" }}>OLTODO</div>
        </div>

        {!token ? (
          <div style={{ textAlign: "center" }}>
            <h3 style={{ fontSize: 20, fontWeight: 800, marginBottom: 8 }}>Lien invalide</h3>
            <p style={{ fontSize: 14, color: "#999", lineHeight: 1.6 }}>
              Ce lien de réinitialisation est manquant ou incomplet. Refais une demande depuis la page de connexion.
            </p>
          </div>
        ) : done ? (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <h3 style={{ fontSize: 20, fontWeight: 800, marginBottom: 8 }}>Mot de passe mis à jour</h3>
            <p style={{ fontSize: 14, color: "#999", lineHeight: 1.6 }}>Tu vas être redirigé vers la page de connexion...</p>
          </div>
        ) : (
          <>
            <h3 style={{ fontSize: 22, fontWeight: 800, marginBottom: 8 }}>Nouveau mot de passe</h3>
            <p style={{ fontSize: 14, color: "#999", marginBottom: 24, lineHeight: 1.6 }}>Choisis un nouveau mot de passe pour ton compte.</p>

            {error && (
              <div style={{ backgroundColor: "#F5F5F5", border: "1px solid #E0E0E0", borderRadius: 12, padding: "12px 16px", color: "#0a0a0a", fontSize: 13, marginBottom: 20, fontWeight: 600 }}>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 11, fontWeight: 700, color: "#999", display: "block", marginBottom: 8, textTransform: "uppercase", letterSpacing: 0.8 }}>Nouveau mot de passe</label>
                <div style={{ border: "1.5px solid #E0E0E0", borderRadius: 14, padding: "13px 16px", backgroundColor: "#FAFAFA" }}>
                  <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••"
                    style={{ flex: 1, border: "none", backgroundColor: "transparent", fontSize: 15, outline: "none" }} />
                </div>
              </div>

              <div style={{ marginBottom: 24 }}>
                <label style={{ fontSize: 11, fontWeight: 700, color: "#999", display: "block", marginBottom: 8, textTransform: "uppercase", letterSpacing: 0.8 }}>Confirmer le mot de passe</label>
                <div style={{ border: "1.5px solid #E0E0E0", borderRadius: 14, padding: "13px 16px", backgroundColor: "#FAFAFA" }}>
                  <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="••••••••"
                    style={{ flex: 1, border: "none", backgroundColor: "transparent", fontSize: 15, outline: "none" }} />
                </div>
              </div>

              <button type="submit" disabled={loading} style={{
                width: "100%", backgroundColor: "#0a0a0a", color: "white",
                borderRadius: 14, padding: "15px", fontSize: 15, fontWeight: 700,
                border: "none", cursor: "pointer", opacity: loading ? 0.7 : 1,
              }}>{loading ? "..." : "Réinitialiser mon mot de passe"}</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
